import React from "react";
import CustomTooltip from "../Tooltip";
import { ADDRESS_STATUS } from "../../constants/CommonConstants";

import verifiedIcon from "../../assets/icons/verified-icon.svg";
import unverifiedIcon from "../../assets/icons/unverified-icon.svg";
import pendingIcon from "../../assets/icons/pending-icon.svg";

export const getAddressStatusIcon = (status: any) => {
  if (status === ADDRESS_STATUS.VERIFIED) {
    return (
      <CustomTooltip title="Address is Verified">
        <img src={verifiedIcon} alt="verified-icon" />
      </CustomTooltip>
    );
  } else if (status === ADDRESS_STATUS.UNVERIFIED) {
    return (
      <CustomTooltip title="Address is Unverified">
        <img src={unverifiedIcon} alt="unverified-icon" />
      </CustomTooltip>
    );
  } else {
    return (
      <CustomTooltip title="Address Verification Pending">
        <img src={pendingIcon} alt="pending-icon" />
      </CustomTooltip>
    );
  }
};
